import type { AgentAnswerRecap, AgentChatEntry, AgentConversation, AgentQuestion, AgentQuestionAnswer, AgentTurnRequest } from './types';

export const isQuestionAnswered = (question: AgentQuestion, answer?: AgentQuestionAnswer) => {
    if (!answer) return false;
    if (answer.skipped) return !question.required && !answer.text?.trim() && !answer.optionIds.length;
    if (answer.text?.trim()) return question.allowFreeText && answer.text.trim().length <= 4000 && !answer.optionIds.length;
    return (
        question.type !== 'text' &&
        answer.optionIds.length > 0 &&
        (question.type === 'multiple' || answer.optionIds.length === 1) &&
        new Set(answer.optionIds).size === answer.optionIds.length &&
        answer.optionIds.every((id) => question.options.some((option) => option.id === id))
    );
};

export const submissionEntry = (request: AgentTurnRequest): AgentChatEntry | null =>
    request.submission
        ? {
              id: `request-${request.requestId}`,
              role: 'merchant',
              requestId: request.requestId,
              text: request.submission.text,
              answers: request.submission.answers,
              attachments: (request.submission.attachments ?? []).map((attachment, index) => ({
                  ...attachment,
                  id: `request-${request.requestId}-attachment-${index}`,
                  previewUrl: attachment.url
              }))
          }
        : null;

export const restoreInteractionEntries = (conversation: AgentConversation): AgentChatEntry[] => {
    const requests = conversation.requests ?? [];
    const linkedTurns = new Set(requests.flatMap((request) => (request.turn?.turnId ? [request.turn.turnId] : [])));
    const entries: AgentChatEntry[] = conversation.turns
        .filter((turn) => !turn.turnId || !linkedTurns.has(turn.turnId))
        .map((turn, index) => ({ id: `restored-${turn.turnId ?? index}`, role: 'agent', turn }));
    for (const request of requests) {
        const user = submissionEntry(request);
        if (user) entries.push(user);
        if (request.turn) entries.push({ id: `restored-${request.turn.turnId}`, role: 'agent', turn: request.turn });
    }
    return entries;
};

export const recapToMessage = (recap: AgentAnswerRecap) =>
    'Clarification answers (preferences, not approval to apply changes):\n' +
    recap.answers
        .filter((answer) => !answer.skipped)
        .map((answer) => `${answer.question}: ${answer.text || answer.labels.join(', ')}`)
        .join('\n');
